import React, { useState } from "react";
import { Button1 } from "../../Buttons";
import OrderHistory from "./editModal/OrderHistory";
import {
  createOrderStatus,
  createNordrentOrderStatus,
} from "../../../../redux/Actions/orderAction";
import { useDispatch } from "react-redux";
import { updateService } from "../../../../redux/Actions/Service/serviceAction";
import ButtonSecondary from "../../ButtonSecondary";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../../../helpers/AsyncMessage";
import SelectInput from "../../SelectInput";

function StatusComponent({
  avalaibleStatus,
  order_histories,
  orderId,
  mode,
  nordrent,
}) {
  const dispatch = useDispatch();
  const [newStatus, setNewStatus] = useState(false);
  const [status, setStatus] = useState(undefined);
  const [errors, setErrors] = useState({});
  const [orderHistories, setOrderHistories] = useState(order_histories);

  const rebuildStatus = () => {
    let arrays = [];
    avalaibleStatus.forEach((e) => {
      const findDub = arrays.find((d) => d.title == e.title);
      if (findDub) return;
      arrays.push(e);
    });
    return arrays;
  };

  return (
    <div className="bg-silver col-12 py-3">
      <div className="table-responsive">
        <table className="table table-sm mb-0">
          <tbody>
            {orderHistories.length > 0 &&
              orderHistories.map((item, index) => (
                <OrderHistory
                  key={index}
                  index={index}
                  item={item}
                  color={
                    mode == "Servisas"
                      ? avalaibleStatus.find((d) => d.label == item.body)?.color
                      : false
                  }
                />
              ))}
          </tbody>
        </table>
      </div>

      {avalaibleStatus.length > 0 && (
        <>
          <div className="d-flex mt-3">
            {newStatus && (
              <>
                <div className="w-75 mr-3">
                  <SelectInput
                    placeholder={"Status"}
                    dropdownMatchSelectWidth={false}
                    options={
                      mode == "Servisas" ? avalaibleStatus : rebuildStatus()
                    }
                    value={status}
                    onChange={(e) => setStatus(e)}
                    error={errors.status}
                  />
                </div>
                <div
                  className="w-25 text-right"
                  style={{
                    height: 32,
                  }}
                >
                  <ButtonSecondary
                    onClick={async () => {
                      const key = "create_new_status";
                      try {
                        antdAsyncMessageLoading({ key });
                        if (!status) {
                          setErrors({ status: "Select a status." });
                          throw new Error("Select a status.");
                        }
                        if (mode == "Servisas") {
                          const { success } = await dispatch(
                            updateService({ status, id: orderId })
                          );

                          if (!success) {
                            throw new Error("Error occurred");
                          }
                        } else {
                          const { success, error, data } = await dispatch(
                            (nordrent
                              ? createNordrentOrderStatus
                              : createOrderStatus)(orderId, { status_id: status })
                          );
                          if (success && data) {
                            setOrderHistories(data?.order_histories || []);
                          }
                          if (!success) {
                            throw new Error(error || "Error occurred");
                          }
                        }

                        setStatus(undefined);
                        setNewStatus(false);
                        setErrors({});
                        antdAsyncMessageSuccess({ key });
                      } catch (err) {
                        console.log("ERROR: ?", err);
                        antdAsyncMessageError({ key, text: err?.message });
                      }
                    }}
                  >
                    Save
                  </ButtonSecondary>
                </div>
              </>
            )}
          </div>
          {newStatus && <div className="text-danger">{errors.error}</div>}
          <div className="py-4">
            <div style={{ position: "relative" }}>
              <Button1
                style={{
                  position: "absolute",
                  top: "-16px",
                  left: "50%",
                  transform: "translate(-50%, 0px)",
                }}
                text={newStatus ? "Cancel" : "Add a new status"}
                option={newStatus ? "minus" : "plus"}
                onClick={() => setNewStatus(!newStatus)}
              />
              <hr />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default StatusComponent;
